<!-- <template>
    <div class="mainContainer">
        <div class="headerlogin d-flex flex-column align-items-center my-4">
            <img class="imgLogo" src="../assets/letrasLogo.png" alt="logo">
            <h1 class="display-6 mb-4">TimeSheet</h1>
        </div>
        <Authenticator :form-fields="formFields">
        </Authenticator>  
    </div>

  
</template> -->
<template>
  <div class="auth-background">
    <div style="background: white; padding: 40px; border-radius: 20px; min-width: 400px; max-width: 500px;">
      
      <div v-if="!amplifyReady" style="text-align: center; padding: 20px;">
        <p>Cargando Amplify...</p>
      </div>
      
      <div v-else style="width: 100%;">
        <Authenticator 
          :hide-sign-up="false"
          :form-fields="formFields"
        >
          <!-- Header personalizado -->
          <template v-slot:header>
            <div style="text-align: center; padding: 20px;">
              <img src="../assets/letrasLogo.png" alt="SRK Logo" style="max-width: 164px; margin-bottom: 10px;" />
              <h3 style="margin: 10px 0;">TimeSheet</h3>
              <div v-html="envBadgeHTML"></div>
            </div>
          </template>
          
          <!-- Contenido cuando ya está autenticado -->
          <template v-slot="{ user }">
            <div style="text-align: center; padding: 20px;">
              <p>Redirigiendo...</p>
            </div>
          </template>
          
          <!-- Footer personalizado -->
          <template v-slot:footer>
            <div style="text-align: center; padding: 10px; color: #888; font-size: 0.9em;">
              <p>SRK | Argentina</p>
            </div>
          </template>
        </Authenticator>
      </div>
      
    </div>
  </div>
</template>

<script setup>

import { Authenticator } from '@aws-amplify/ui-vue'
import { Amplify } from 'aws-amplify'
import { getCurrentUser } from 'aws-amplify/auth'
import { Hub } from 'aws-amplify/utils'
import router from '../router/index'

import envBadge from "../utils/environmentBadge.js";

import { onMounted, computed, ref, nextTick } from 'vue'
import { useAuthStore } from '../stores/auth.js'

const authStore = useAuthStore()

const amplifyReady = ref(false)
const isProcessingLogin = ref(false)

onMounted(async () => {
  authStore.resetAuth()

  await nextTick()
  amplifyReady.value = true

  try {
    const user = await getCurrentUser()
    if (user) {
      router.push('/carga')
    }
  } catch (err) {
    // No hay sesión activa, mostrar login
  }
})

const envBadgeHTML = computed(() => envBadge.getBadgeHTML());

const formFields = {
    signUp: {
      name: {
        order: 1,
        placeholder: 'APELLIDO, Nombres (Ej: GUTIERREZ, Juan Pablo)'
      },
      preferred_username: {
        order: 2,
        placeholder: 'Por Ej. agutierrez'
      },
      email: {
        order: 3
      },
      password: {
        order: 4
      },
      confirm_password: {
        order: 5
      }
    },
}

const listener = async (data) => {
  switch (data.payload.event) {
    case 'signedIn':
      router.push('/carga')
      break;

    case 'signedOut':
      break;
  }
}

Hub.listen('auth', listener);

</script>

<style>
[data-amplify-authenticator] {
  --amplify-font-family: 'Poppins';
  --amplify-components-tabs-item-active-color: var(--srk-primary);
  --amplify-components-tabs-item-focus-color: var(--srk-primary);
  --amplify-components-tabs-item-active-border-color: var(--srk-primary);
}

.amplify-button[data-variation='primary'] {
  background: linear-gradient(
    to right,
    rgb(243,112,32,100%),
    rgb(243,112,32,80%)
  );
}

.amplify-tabs-item[data-state=active] {
    border-color: var(--srk-primary);
    font-size: 1.4rem;
}

.imgLogo {
    margin-top: 50px;
    margin-bottom: 20px;
    max-width: 164px;
    max-height: 44px;
}

.mainContainer {
    height: 100vh;
    background-color: #D6D4D0;
    display: flex;
    flex-direction: column;
    align-items: center;

}





/* Resetear márgenes y padding para esta vista */
html, body {
  margin: 0 !important;
  padding: 0 !important;
  overflow-x: hidden;
}

/* Sobrescribir estilos del layout single-card para esta vista */
.single-card {
  padding: 0 !important;
  margin: 0 !important;
}

.single-card .dx-card.content {
  width: 100% !important;
  height: 100% !important;
  margin: 0 !important;
  padding: 0 !important;
  border-radius: 0 !important;
  box-shadow: none !important;
  border: none !important;
  background: transparent !important;
}

.loging-header {
  background-color: white;
  border-radius: 20px 20px 0 0;
}

.footer-content {
  background-color: white;
  border-radius: 0 0 20px 20px;
  border: none !important;
  font-size: .7em;
  color: darkgrey;
}

[data-amplify-authenticator] [data-amplify-router] {
  border-style: none !important;
}

/* Contenedor principal con imagen de fondo y capa naranja */
.auth-background {
  position: fixed; /* Cambiado a fixed para ocupar toda la ventana */
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100vw;
  height: 100vh;
  margin: 0;
  padding: 0;
  background-image: url('../assets/glenn-carstens-peters-RLw-UC03Gwc-unsplash.jpg');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 0; /* Para estar debajo de otros elementos si es necesario */
}

/* Capa naranja semi-transparente sobre la imagen */
.auth-background::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(243, 112, 32, 0.7); /* Color naranja con transparencia */
  background-color: #95939374;
  z-index: 1;
}

/* Asegurar que el contenido esté por encima de la capa naranja */
.auth-background > * {
  position: relative;
  z-index: 2;
}

/* TEMPORAL: Forzar visibilidad del Authenticator */
[data-amplify-authenticator] {
  display: block !important;
  visibility: visible !important;
  opacity: 1 !important;
  position: relative !important;
  z-index: 999 !important;
  background: white !important;
  padding: 20px !important;
  border-radius: 20px !important;
  min-width: 400px !important;
  max-width: 500px !important;
}

.header {
  display: none;
}

[data-amplify-authenticator] {
  --amplify-font-family: "Poppins";
  --amplify-components-tabs-item-active-color: var(--srk-primary);
  --amplify-components-tabs-item-focus-color: var(--srk-primary);
  --amplify-components-tabs-item-active-border-color: var(--srk-primary);
}
.amplify-button[data-variation="primary"] {
  background: linear-gradient(
    to right,
    rgb(243, 112, 32, 100%),
    rgb(243, 112, 32, 80%)
  );
}
.amplify-tabs-item[data-state="active"] {
  border-color: var(--srk-primary);
  font-size: 1.4rem;
}
.imgLogo {
  margin-top: 50px;
  margin-bottom: 20px;
  max-width: 164px;
  max-height: 44px;
}
.mainContainer {
  height: 100vh;
  background-color: #d6d4d0;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 600px;
}
</style>